/**
 * Free-tier map helpers — no Google Maps API key required.
 *
 * - `mapsLinkFor` builds a universal Google Maps deep link. The OS handoff
 *   takes care of opening Apple Maps / Google Maps / etc.
 * - `mapsEmbedFor` returns the URL for an iframe embed using Google Maps'
 *   `output=embed` pattern, which doesn't require an API key.
 */

export function mapsLinkFor(addressOrPlace: string): string {
  const q = encodeURIComponent(addressOrPlace.trim());
  return `https://www.google.com/maps/search/?api=1&query=${q}`;
}

export function mapsEmbedFor(addressOrPlace: string): string {
  const q = encodeURIComponent(addressOrPlace.trim());
  return `https://maps.google.com/maps?q=${q}&output=embed`;
}

/** Universal "Get directions" deep link — OS opens Apple/Google Maps to route. */
export function directionsLinkFor(addressOrPlace: string): string {
  const q = encodeURIComponent(addressOrPlace.trim());
  return `https://www.google.com/maps/dir/?api=1&destination=${q}`;
}
